import styled, { css } from 'styled-components'
import theme from '../../../styled/theme'
import fonts from '../../../styled/fonts'

export const Container =  styled.div`
display:flex;
flex-direction:column;
gap:32px;
width:100%;
`